declare let THREE: any;

export class Sphere extends (THREE.Mesh as { new(geometry, material): any; }) {


    public static readonly Name = 'Sphere';

    constructor(color) {
        const geometry = new THREE.SphereGeometry(2);
        const material = new THREE.MeshBasicMaterial({ color, depthWrite: false, depthTest: false });

        super(geometry, material);
        this.name = Sphere.Name;
    }

}


// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/Sphere.ts